import brandState from '@/state/slices/brand//state';
import exposerState from '@/state/slices/exposer/state';
import iconsState from '@/state/slices/icons/state';
import navigationState from '@/state/slices/navigation/state';
import optionsState from '@/state/slices/options/state';
import refState from '@/state/slices/ref/state';
import savedBuildsState from '@/state/slices/saved-builds/state';
import secondaryNavState from '@/state/slices/secondary-nav/state';
import type { IState } from '@/state/slices/typings';
import windowState from '@/state/slices/window/state';

const state: IState = {
	...iconsState,
	...brandState,
	...windowState,
	...navigationState,
	...refState,
	...exposerState,
	...optionsState,
	...savedBuildsState,
	...secondaryNavState,
};

export default state;
